<template>
  <div>
    <div class="card height-100">
      <header class="header-card">
        <p>{{ $t('modificationOrdreTravailAffichage.remplacementFaceOT.detail.title')}}</p>
      </header>
      <div class="card-content">
        <div class="columns is-multiline">
          <div class="column is-narrow">
            <b-field
              :label="$t('modificationOrdreTravailAffichage.remplacementFaceOT.detail.codeFace')"
              custom-class="has-text-default is-italic is-marginless
                     mgr-25px has-text-weight-light">
              <p class="has-text-weight-bold">{{ face.produitReference}}</p>
            </b-field>
          </div>
          <div class="column is-narrow" >
            <b-field
              :label="$t('modificationOrdreTravailAffichage.remplacementFaceOT.detail.codePanneau')"
              custom-class="has-text-default is-italic is-marginless
                     mgr-25px has-text-weight-light">
              <p class="has-text-weight-bold">{{ face.materielCode }}</p>
            </b-field>
          </div>
          <div class="column is-4">
            <b-field
              :label="$t('modificationOrdreTravailAffichage.remplacementFaceOT.detail.adresse')"
              custom-class="has-text-default is-italic
              is-marginless has-text-weight-light mgr-25px">
              <p class="has-text-weight-bold">
                {{ getAdresse(face.dispositifAdresse) }}<br/>
                {{ face.dispositifAdresse.codePostal }}, {{ face.dispositifAdresse.ville }}
              </p>
            </b-field>
          </div>
          <div class="column is-1">
            <b-field
              :label="$t('modificationOrdreTravailAffichage.remplacementFaceOT.detail.format')"
              custom-class="has-text-default is-italic is-marginless has-text-weight-light">
              <p class="has-text-weight-bold">{{ face.format}}</p>
            </b-field>
          </div>
          <div class="column">
            <b-field
              :label="$t('modificationOrdreTravailAffichage.remplacementFaceOT.detail.pose')"
              custom-class="has-text-default is-italic is-marginless has-text-weight-light">
              <p class="is-prewrap has-text-weight-bold">{{ face.pose }}</p>
            </b-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import adressFullStringGetter from '@/services/general/adressFullStringGetter';

export default {
  name: 'faceARemplacerDetail',
  props: {
    face: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getAdresse(adresse) {
      return adressFullStringGetter(adresse, true);
    },
  },
};
</script>
